import { render } from "./ModalFocusPointFrame.vue?vue&type=template&id=738d2601&scoped=true"
import script from "./ModalFocusPointFrame.vue?vue&type=script&lang=js"
export * from "./ModalFocusPointFrame.vue?vue&type=script&lang=js"

import "./ModalFocusPointFrame.vue?vue&type=style&index=0&id=738d2601&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738d2601"]])

export default __exports__